import styled from '@emotion/styled';
import {Grid} from '@mui/material';
import {APP} from 'src/styles/variables';
import backgroundImage from 'src/assets/images/low_res_background_light.png';

export const WidgetsHomePageWrapperGrid = styled(Grid)`
  width: 100%;
  display: flex;
  height: calc(100vh - 58px);
`;

export const BackgroundGrid = styled(Grid)`
  width: 100vw;
  background-image: url(${backgroundImage});
  background-repeat: no-repeat;
  background-size: 100% 100%;
`;

export const AppBarGrid = styled(Grid)`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

export const ContentGrid = styled(Grid)`
  box-sizing: border-box;
  height: inherit;
  width: inherit;
  display: flex;
  flex-direction: row;
`;

export const NavbarGrid = styled(Grid)`
  height: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${prop => prop.theme.palette.common.white};
  /* z-index: 1000; */
  box-shadow: ${APP.PALETTE.BOX_SHADOW.MAIN};
`;

export const NavbarDiv = styled('div')`
  height: inherit;
  display: flex;
  width: 100%;
  align-items: center;
  /* margin-top: 8rem; */
  flex-direction: column;
  /* border: 5px solid red; */

  a {
    padding: 0.4rem 2rem;
    text-decoration: none;
    width: 95%;
    justify-content: center;

    /* text-align: center; */
    color: ${prop => prop.theme.palette.common.black};
  }
  // ::selection {
  //   color: ${prop => prop.theme.palette.primary.main};
  // }
  a:hover {
    color: ${prop => prop.theme.palette.primary.main} !important;
    border-radius: 6px;
    background-color: ${prop => prop.theme.palette.common.white};
  }
`;
export const LogoGrid = styled(Grid)`
  display: 'flex';
  align-items: 'center';
  justify-content: 'center';
  background-color: ${prop => prop.theme.palette.common.white};
  margin-top: 5px;
  margin-bottom: 15px;
`;
export const MainContentGrid = styled(Grid)`
  height: inherit;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 1rem;
`;

export const MainContentDiv = styled('div')`
  height: 92vh;
  width: inherit;
  flex: 1;
  display: flex;
  overflow: auto;
  background: #ffffff;
`;

export const ContentGridDiv = styled('div')`
  flex: 1;
  display: flex;
  flex-direction: row;
`;

export const ContentDiv = styled('div')`
  flex: 1;
  /* margin:0.5rem; */
`;
export const TopAppBarDiv = styled('div')`
  // height: 0.5rem;
  // width: inherit;
`;

export const AppBarDiv = styled('div')`
  height: 120;
  width: inherit;
`;

export const IntegrationsGrid = styled(Grid)`
  margin: 4rem auto;
  font-size: 1.5rem;
  color: ${APP.PALETTE.GREY.SHADE_700};
`;

export const MarketplaceGrid = styled(Grid)`
  margin: 4rem auto;
  font-size: 1.5rem;
  color: ${APP.PALETTE.GREY.SHADE_700};
`;

export const PurgeGrid = styled(Grid)`
  margin: 4rem auto;
  font-size: 1.5rem;
  color: ${APP.PALETTE.GREY.SHADE_700};
`;
